import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { DISPATCH_TRIP_TABS } from './dispatch.paths';
import { AssignTripPage } from './pages/AssignTripPage';
import { DispatchBoardPage } from './pages/DispatchBoardPage';
import { DispatchTripPage } from './pages/DispatchTripPage';

export const DISPATCH_ROUTES: RouteObject[] = [
  { path: 'dispatch', element: <DispatchBoardPage /> },
  { path: 'dispatch/trips/:id/assign', element: <AssignTripPage /> },
  ...recordTabRoutes('dispatch/trips/:id', DISPATCH_TRIP_TABS, (tab) => <DispatchTripPage tab={tab} />),
];
